import React, { useState } from "react";
import "./HeroSection.css";
import TitleProps from "../GeneralTemplate/TitleProps";
import aiml from "./AimlImages/ai_image.jpg";
import SectionDescription from "./SectionDescription";
import ".././GeneralTemplate/GeneralTemplate.css";
import EnquiryModal from "../ModelBox/ModelBox";
import Header1 from "./../Header/Header1";
import FooterMain from "./../Footer/FooterMain";
import { customAlert } from "../SweetAlertCommon/Custom";
import axios from "axios";
import { baseURL } from "../../http";
import SmallSnackBar from "../SmallSnackBar/SmallSnackBar";
import UseCaseLeft from "../GeneralTemplate/UseCaseLeft";
import GenAi from "./AImlUsecaseImages/GEN AI.png";
import ProcessProgressCircle from "../ProcessProgressCircle/ProcessProgressCircle";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import WhatsAppButton from "../Whatsapp/WhatsappButton";
import GetInTouch from "../GeneralTemplate/GetInTouch";
import AICapabilities from "../AICapabilities/AICapabilities";
import FAQSection from "../FAQ/FAQSection";

const Title3 = [
  {
    imageSrc: aiml,
    title: "Artificial Intelligence and Machine Learning",
    description:
      "Artificial Intelligence and Machine Learning empower businesses to leverage data insights, automate processes, and enhance decision-making for innovative solutions.",
    buttonLabel: "Reach Out",
  },
];

const useCaseProps1 = {
  imageSrc: GenAi,
  heading: "Chat With your Own Document ",
  problemStatement:
    "<strong>Problem Statement:</strong> Finding information in large documents is slow and frustrating.",
  solution:
    "<strong>Solution:</strong> Use Generative AI to chat with documents. Ask questions and get instant answers from the content.",
  efficiency:
    "<strong>Efficiency Improvement:</strong> Saves up to 70% of time spent searching for information.",
};

// 3D CAD Similarity Search used to be a second card here. It now lives in
// <AICapabilities> alongside the rest of the AI work, so it is not repeated.

const Section1Data = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Services: "",
    Message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      Phone: value,
    }));
  };

  const handleSubmit = async (formData) => {
    setLoading(true);

    try {
      const response = await axios.post(`${baseURL}/reach_out`, formData);
      console.log("Data submitted successfully:", response.data);
      customAlert("", "Form submitted successfully", "success");

      setFormData({
        Name: "",
        Email: "",
        Phone: "",
        Services: "",
        Message: "",
      });

      handleCloseModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      customAlert("", "Failed to submit the form", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SmallSnackBar />
      <Header1 />
      <div className="TitleProps-container">
        {Title3.map((Section1) => (
          <TitleProps
            key={Section1.title}
            imageSrc={Section1.imageSrc}
            title={Section1.title}
            description={Section1.description}
            buttonLabel={Section1.buttonLabel}
            onButtonClick={handleOpenModal}
          />
        ))}
        <SectionDescription />
        <h2 className="use-case-heading">USE CASES</h2>
        <div className="card-container">
          <UseCaseLeft {...useCaseProps1} />
        </div>
      </div>
      <AICapabilities />
      <FAQSection />
      <GetInTouch />
      <FooterMain />
      <WhatsAppButton />
      <ScrollToTop />

      <EnquiryModal
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        handlePhoneChange={handlePhoneChange}
      />

      {loading && (
        <ProcessProgressCircle RequiredProgressName="Submitting your application..." />
      )}
    </>
  );
};

export default Section1Data;
